/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-15 15:21:01
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-03 13:32:43
 * @FilePath: /unifyxp-v2-store-portal/src/components/RangePicker/index.tsx
 */
import React, { useState, useEffect } from 'react'; //,
import moment, { Moment } from 'moment';
import { DatePicker } from 'antd';
// import {
//   combineOccupied,
//   getDisabledDate,
//   getDisabledHours,
//   getDisabledMinutes,
//   getNoEndTimeList,
//   getSortedList,
//   isSelectedValid,
// } from './util';

import styles from './style.module.less';
import { getI18nFromGeneral } from '@/src/tools/tools';
// import lodash from 'lodash';
// import classnames from 'classnames';

const { RangePicker: Range } = DatePicker;

export interface DateRange {
  beginDate: string;
  beginTime: string;
  endDate: string;
  endTime: string;
}

export interface Error {
  hasError: boolean;
  errorMsg: string;
}

type Props = {
  id: string;
  error?: Error;
  size?: 'large' | 'middle' | 'small';
  value: DateRange;
  occupiedRanges: DateRange[];
  hideNoEndTime?: boolean;
  onChange?: (value) => void;
  disabled?: boolean;
};

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm';

function RangePicker(props) {
  const {
    id,
    value = {} as DateRange,
    // occupiedRanges = [],
    onChange,
    error,
    hideNoEndTime,
    size,
    disabled,
  }: Props = props;
  //const sortedOccupiedList = getSortedList(occupiedRanges);
  // const combinedOccupiedList = combineOccupied(sortedOccupiedList);
  // const noEndTimeList = getNoEndTimeList(occupiedRanges);
  const [range] = useState<'start' | 'end'>('start');
  const [dates, setDates] = useState<[Moment, Moment]>([null, null]);
  //const [clickedDate, setClickedDate] = useState<Moment>(null);
  const syncValueAndDate = () => {
    const { beginDate, beginTime, endDate, endTime } = value;

    const startDate =
      beginDate && beginTime
        ? moment(`${beginDate} ${beginTime}`, DATE_FORMAT)
        : null;
    const finishDate =
      endDate && endTime ? moment(`${endDate} ${endTime}`, DATE_FORMAT) : null;
    setDates([startDate, finishDate]);
  };

  useEffect(() => {
    syncValueAndDate();
  }, [value]);

  // useEffect(() => {
  //   const data = isSelectedValid(
  //     range,
  //     clickedDate,
  //     combinedOccupiedList,
  //     noEndTimeList,
  //     sortedOccupiedList,
  //     dates,
  //   );
  //   if (!data.isValid) {
  //     if (range === 'start') {
  //       setDates([data.aviaibleDateTime, dates[1]]);
  //     } else {
  //       const newDates: any = lodash.cloneDeep([
  //         dates[0],
  //         data.aviaibleDateTime,
  //       ]);
  //       setTimeout(() => setDates([dates[0], null]), 0);
  //       setTimeout(() => setDates(newDates), 50);
  //     }
  //   } else {
  //     if (clickedDate) {
  //       if (range === 'start') {
  //         setDates([clickedDate, dates[1]]);

  //       } else {
  //         const newDates: any = lodash.cloneDeep([dates[0], clickedDate]);
  //         setDates(newDates);
  //       }
  //     }
  //   }
  // }, [clickedDate]);

  // const dateDisable = (current) => {
  //   return getDisabledDate(range, dates, current, occupiedRanges);
  // };

  // const disabledTime = (date: Moment, rang: 'start' | 'end') => {
  //   if (range !== rang) {
  //     setRange(rang);
  //   }
  //   if (date?.format(DATE_FORMAT) !== clickedDate?.format(DATE_FORMAT)) {
  //     setClickedDate(date);
  //   }
  //   return {
  //     disabledHours: () => {
  //       let arr = [];
  //       arr = getDisabledHours(
  //         rang,
  //         date,
  //         dates,
  //         combinedOccupiedList,
  //         noEndTimeList,
  //       );
  //       return arr;
  //     },
  //     disabledMinutes: (selected) => {
  //       let arr = [];
  //       arr = getDisabledMinutes(
  //         rang,
  //         date,
  //         selected,
  //         combinedOccupiedList,
  //         dates,
  //         noEndTimeList,
  //       );
  //       return arr;
  //     },
  //   };
  // };

  const handleCalendarChange = (dates) => {
    setDates(dates ? dates : [null, null]);
  };

  const handleChange = (dates: [Moment, Moment | null]) => {
    const dateList = dates ? dates : [null, null];
    const start = dateList[0];
    const end = dateList[1];
    const beginDate = start ? moment(start).format('YYYY-MM-DD') : null;
    const beginTime = start ? moment(start).format('HH:mm') : null;
    const endDate = end ? moment(end).format('YYYY-MM-DD') : null;
    const endTime = end ? moment(end).format('HH:mm') : null;
    onChange({ beginDate, beginTime, endDate, endTime });
  };

  const isCurrentTimeValid = { isValid: true };
  // isSelectedValid(
  //   range,
  //   moment(),
  //   combinedOccupiedList,
  //   noEndTimeList,
  //   sortedOccupiedList,
  //   dates,
  // );

  // const isNoEndTimeValid = () => {
  //   const start = dates[0];
  //   return (
  //     noEndTimeList.length === 0 &&
  //     combinedOccupiedList.every(([s, e]) => e.isBefore(start))
  //   );
  // };

  // const renderPanel = (Panel: any) => {
  //   return (
  //     <div
  //       className={classnames({
  //         [styles.disabled]:
  //           range === 'start'
  //             ? !isCurrentTimeValid.isValid
  //             : !isNoEndTimeValid(),
  //         [styles.range]:
  //           range === 'start' ? isCurrentTimeValid.isValid : isNoEndTimeValid(),
  //       })}>
  //       <div
  //         className={styles.panelTitle}>{`Select ${range} date and time`}</div>
  //       {Panel}
  //     </div>
  //   );
  // };

  return (
    <div id={id}>
      <Range
        onOpenChange={function (e) {
          const startHasValue = value.beginDate && value.beginTime;
          if (!e && !startHasValue) {
            //粘是
            setTimeout(() => {
              syncValueAndDate();
            });
          }
        }}
        style={{
          border: error?.hasError ? 'solid 1px #ff695f' : undefined,
          width: '100%',
        }}
        size={size}
        disabled={disabled}
        allowEmpty={[false, true]}
        value={dates}
        showTime
        order
        format={DATE_FORMAT}
        showSecond={false}
        // disabledDate={dateDisable}
        // disabledTime={disabledTime}
        onCalendarChange={handleCalendarChange}
        //panelRender={renderPanel}
        //onOk={() => handleChange(dates)}
        onChange={handleChange}
        ranges={
          range === 'start'
            ? {
                [getI18nFromGeneral('general.rangePicker.current_time')]:
                  () => {
                    if (isCurrentTimeValid.isValid) {
                      return [moment(), dates[1]];
                    } else {
                    }
                  },
              }
            : !hideNoEndTime
            ? {
                [getI18nFromGeneral('general.rangePicker.no_end')]: [
                  dates[0],
                  null,
                ],
              }
            : {}
        }
      />
      {error?.hasError && <div className={styles.error}>{error.errorMsg}</div>}
    </div>
  );
}

export default RangePicker;
